let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lU1wr"), load("29wqP"), load("iB2zz"), load("c6MKV"), load("jjWia")]).then(() => parcelRequire('c8BWz'));